{
  "enum": {
    "IxcFundingV1AccountNumberStatus": {
      "ACTIVE": "Active",
      "DISABLED": "Disabled",
      "PENDING": "Pending",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcFundingV1BankAccountOwnerType": {
      "BUSINESS": "Business",
      "PERSON": "Person",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcFundingV1BankAccountType": {
      "CHECKING": "Checking",
      "SAVINGS": "Savings",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcFundingV1BatchAllocationStatus": {
      "CANCELED": "Canceled",
      "COMPLETED": "Completed",
      "ERRORED": "Errored",
      "PENDING": "Pending",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcFundingV1BatchTransferStatus": {
      "APPLYING": "Applying",
      "DONE": "Done",
      "ERROR": "Error",
      "PENDING": "Pending",
      "REJECTED": "Rejected",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcFundingV1CheckOutcome": {
      "FAILED": "Failed",
      "PASSED": "Passed",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcFundingV1SourceStatus": {
      "ACTIVE": "Active",
      "ARCHIVED": "Archived",
      "INVALID": "Invalid",
      "PENDING": "Pending",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcFundingV1TransferStatus": {
      "CANCELED": "Canceled",
      "CREATED": "Created",
      "PENDING": "Pending",
      "PROCESSING": "Processing",
      "REJECTED": "Rejected",
      "RETURNED": "Returned",
      "SUCCESS": "Success",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcFundingV1TransferTaskOutcome": {
      "ERROR": "Error",
      "HELD": "Held",
      "PENDING": "Pending",
      "SUCCESS": "Success",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcFundingV1AccountNumberQueryServiceAccountNumberListFilterableFields": {
      "accountId": "Account",
      "accountNumberId": "Account Number ID",
      "data": {
        "externalId": "External ID",
        "sourceId": "Source"
      },
      "programId": "Program",
      "status": "Status"
    },
    "IxcFundingV1BatchAllocationQueryServiceBatchAllocationListFilterableFields": {
      "batchAllocationId": "Batch Allocation",
      "batchTransferId": "Batch Transfer",
      "dstAccountId": "Destination Account",
      "programId": "Program",
      "srcAccountId": "Source Account",
      "status": "Status"
    },
    "IxcFundingV1BatchTransferQueryServiceBatchTransferListFilterableFields": {
      "batchTransferId": "Batch Transfer",
      "programId": "Program",
      "status": "Status"
    },
    "IxcFundingV1SourceQueryServiceSourceListFilterableFields": {
      "accountId": "Account",
      "data": {
        "accountNumberId": "Account Number",
        "spec": {
          "isPrimary": "Is Primary",
          "sourceType": {
            "!type": "Source Type"
          }
        }
      },
      "programId": "Program",
      "sourceId": "Source",
      "status": "Status"
    },
    "IxcFundingV1TransferQueryServiceTransferListFilterableFields": {
      "accountId": "Account",
      "data": {
        "source": {
          "isPrimary": "Is Primary",
          "sourceType": {
            "!type": "Source Type"
          }
        },
        "spec": {
          "transferType": {
            "!type": "Type"
          }
        }
      },
      "programId": "Program",
      "sourceId": "Source",
      "status": "Status",
      "transferId": "Transfer"
    }
  },
  "oneOf": {
    "IxcFundingV1AccountNumberEventType": {
      "created": "Created",
      "disabled": "Disabled",
      "reenabled": "Re-Enabled",
      "requested": "Requested",
      "sourceCreated": "Source Created"
    },
    "IxcFundingV1BatchAllocationEventType": {
      "canceled": "Canceled",
      "completed": "Completed",
      "created": "Created",
      "errored": "Errored",
      "holdUpdated": "Hold Updated"
    },
    "IxcFundingV1BatchTransferEventType": {
      "approved": "Approved",
      "completed": "Completed",
      "errored": "Errored",
      "externalTransferUpdated": "External Transfer Updated",
      "internalTransferUpdated": "Internal Transfer Updated",
      "rejected": "Rejected",
      "requested": "Requested"
    },
    "IxcFundingV1BatchTransferType": {
      "achPull": "ACH Pull",
      "achPush": "ACH Push"
    },
    "IxcFundingV1CreatableSourceType": {
      "achSource": "ACH Source",
      "domesticWireSource": "Domestic Wire Source",
      "plaidProcessorTokenSource": "Plaid Processor Token Source"
    },
    "IxcFundingV1ExternallyManaged": {
      "plaidSource": "Plaid Source"
    },
    "IxcFundingV1SourceEventType": {
      "archived": "Archived",
      "created": "Created",
      "invalidExternalToken": "Invalid External Token",
      "requested": "Requested",
      "updated": "Updated"
    },
    "IxcFundingV1SourceType": {
      "accountNumberSource": "Account Number",
      "achSource": "ACH",
      "domesticWireSource": "Domestic Wire",
      "plaidProcessorTokenSource": "Plaid Processor Token Source"
    },
    "IxcFundingV1SourceValidation": {
      "external": "External"
    },
    "IxcFundingV1TransferCheckType": {
      "clearingApproval": "Clearing Approval",
      "fundingHold": "Funding Hold",
      "programApproval": "Program Approval"
    },
    "IxcFundingV1TransferCreateRequestSpec": {
      "achPull": "ACH Pull",
      "achPush": "ACH Push",
      "wirePush": "Wire Push"
    },
    "IxcFundingV1TransferEventType": {
      "approved": "Approved",
      "canceled": "Canceled",
      "checkResult": "Check Result",
      "checksPassed": "Checks Passed",
      "created": "Created",
      "denied": "Denied",
      "incomingPaymentSettled": "Incoming Payment Settled",
      "rejected": "Rejected",
      "returned": "Returned",
      "submitted": "Submitted"
    },
    "IxcFundingV1TransferType": {
      "achPull": "ACH Pull",
      "achPush": "ACH Push",
      "incomingTransfer": "Incoming Transfer",
      "wirePush": "Wire Push"
    }
  },
  "searchEnum": {
    "IxcFundingV1AccountNumberQueryServiceAccountNumberListSearchableFields": {
      "data": {
        "spec": {
          "sourceType": {
            "bankDetails": {
              "accountNumber": "Account Number"
            }
          }
        }
      }
    },
    "IxcFundingV1SourceQueryServiceSourceListSearchableFields": {
      "data": {
        "spec": {
          "sourceType": {
            "accountNumberSource": {
              "bankDetails": {
                "accountNumber": "Account Number"
              }
            },
            "achSource": {
              "bankDetails": {
                "accountNumber": "ACH Source: Account Number"
              }
            },
            "domesticWireSource": {
              "bankDetails": {
                "accountNumber": "Domestic Wire Source: Account Number"
              }
            }
          }
        }
      }
    },
    "IxcFundingV1TransferQueryServiceTransferListSearchableFields": {
      "data": {
        "source": {
          "sourceType": {
            "accountNumberSource": {
              "bankDetails": {
                "accountNumber": "Account Number"
              }
            },
            "achSource": {
              "bankDetails": {
                "accountNumber": "ACH Source: Account Number"
              }
            },
            "domesticWireSource": {
              "bankDetails": {
                "accountNumber": "Domestic Wire Source: Account Number"
              }
            }
          }
        }
      }
    }
  },
  "sortEnum": {
    "IxcFundingV1AccountNumberQueryServiceAccountNumberListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcFundingV1BatchAllocationQueryServiceBatchAllocationListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcFundingV1BatchTransferQueryServiceBatchTransferListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcFundingV1SourceQueryServiceSourceListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcFundingV1TransferQueryServiceTransferListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}